<template>
  <div id="app">

    <div class="sticky-nav px-4">

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Vrachtwagens</h1>
    </div>

    <div class="dropdown">
      <button class="btn btn-dark" type="button" id="dropdownMenuButton" v-on:click="modalToevoegenVrachtwagen()">
        <i class="fas fa-plus"></i> Vrachtwagen toevoegen
      </button>
    </div>

    </div>

    <br /><br />

    <vue-good-table v-if="vrachtwagens && vrachtwagens.length"
          class="mb-3 px-4"
          @on-selected-rows-change="selectionChanged"
          @on-cell-click="onRowClick"
          :columns="vrachtwagenColumns"
          :rows="vrachtwagens"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 100,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
          :selectOptions="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div class="modal fade" id="vrachtwagenModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

              <div v-if="vrachtwagen">
                <label>Beschrijving</label><input type="text" class="form-control" v-model="vrachtwagen.beschrijving" placeholder="Beschrijving" />
                <label>Nummerplaat</label><input type="text" class="form-control" v-model="vrachtwagen.nummerplaat" placeholder="Nummerplaat" />
              </div>

          </div>
          <div class="modal-footer">
            <button v-if="checkNewVrachtwagen === false" type="button" class="btn btn-danger" v-on:click="deleteVrachtwagen()">Verwijderen</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Sluiten</button>
            <button v-if="checkNewVrachtwagen" type="button" class="btn btn-primary" v-on:click="createVrachtwagen()">Opslaan</button>
            <button v-else type="button" class="btn btn-primary" v-on:click="updateVrachtwagen()">Aanpassen</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';

export default {
  name: 'app',
  components: {

  },
  data() {
    return{
      checkNewVrachtwagen: false,
      importType : '-1',
      importCategory: '-1',
      types: [
        {
          name: 'Vrachtwagens'
        },
        {
          name: 'Contacten'
        },
        {
          name: 'Leveradressen'
        }
      ],
      editModalTitle: '',
      vrachtwagen: {
      },
      vrachtwagens: {
        attributes: [],
        related: []
      },
      vrachtwagenColumns: [
        {label: 'Beschrijving', field: 'beschrijving', filterOptions: {enabled: true}},
        {label: 'Nummerplaat', field: 'nummerplaat', filterOptions: {enabled: true}}
      ],
      attrPos: 0
    }
  },
  mounted (){
    this.getVrachtwagens();
  },
  methods: {
    grootteFn(rowObj){
      return rowObj.grootte + ' m³';
    },
    getVrachtwagens(){

      axios
        .get('https://hofman.weblion.be/api/vrachtwagens/')
        .then(response => {
          this.vrachtwagens = response.data;
          console.log(this.vrachtwagens);
        })
    },
    deleteVrachtwagen(){

      axios
        .delete('https://hofman.weblion.be/api/vrachtwagens/', { data: {
          vrachtwagen_id : this.vrachtwagen.id
        }})
        .then(response => {
          this.getVrachtwagens();
          $("#vrachtwagenModal").modal('hide');
          console.log(response.data);
        })

    },
    updateVrachtwagen(){

      axios.put('https://hofman.weblion.be/api/vrachtwagens/', {
        vrachtwagen : this.vrachtwagen
      })
      .then(response => {
        this.getVrachtwagens();
        $("#vrachtwagenModal").modal('hide');
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    },
    createVrachtwagen(){

      axios.post('https://hofman.weblion.be/api/vrachtwagens/', {
        vrachtwagen : this.vrachtwagen
      })
      .then(response => {
        this.getVrachtwagens();
        $("#vrachtwagenModal").modal('hide');
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    },
    modalToevoegenVrachtwagen(){
      this.vrachtwagen = {};
      this.editModalTitle = 'Vrachtwagen toevoegen';

      this.checkNewVrachtwagen = true;

      $("#vrachtwagenModal").modal('show');
    },
    onRowClick(table){

      this.editModalTitle = 'Vrachtwagen aanpassen';
      this.vrachtwagen = table.row;

      this.checkNewVrachtwagen = false;

      $("#vrachtwagenModal").modal('show');
    },
    selectionChanged(table){
      this.vrachtwagensSelected = table.selectedRows;
    },
    modalAanpassenVrachtwagen(){

      this.checkNewVrachtwagen = false;
      this.editModalTitle = 'Vrachtwagen aanpassen';

      $("#vrachtwagenModal").modal('show');

    },
    sVrachtwagen(){

      axios
        .post('https://hofman.weblion.be/api/vrachtwagens/update.php',{
          vrachtwagen : this.vrachtwagen
        })
        .then((res) => {
          console.log(res);
          this.getVrachtwagens();
        })
        .then(function(){ $("#vrachtwagenModal").modal('hide'); })

    }


  }
}
</script>

<style>
button{
  margin-right: 10px;
}
.table thead th{
  text-align: left !important;
}
.pager ul{
  list-style-type: none;
}
.pager ul li{
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,.modal select{
  margin-bottom: 5px;
}
.modal-body label{
  display: inline-block;
  width: 32%;
}

.modal-body .form-control{
  display: inline-block;
  width: 68%;
}

.modal-body select{
  text-indent: 5px;
}

#exampleModal input{
  display: block;
  width: 100%;
}

#importModal .modal-body label{
  width: auto;
}

#importModal input, #importModal select{
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper, #importModal form{
  width: 100%;
}
#importModal select{
  margin-left: 1%;
}

#importModal .fullw{
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select{
  margin: 0;
}

#importModal .fullw input{
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown{
  display: inline-block;
}
.dropdown-item:hover{
  cursor: pointer !important;
}
.dropdown-item i{
  margin-right:3px;
}
@media (min-width: 576px){
  .modal-dialog {
      max-width: 550px;
      margin: 1.75rem auto;
  }
}
.groupedState{
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td{
  padding: 2px 10px;
}

#autoGroupModal .modal-title span{
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input{
  width: 100%;
}

#autoGroupModal .form-check-input{
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
    display: inline-block !important;
    width: 68% !important;
    margin-bottom: 5px !important;
}

.sticky-nav{
  position: fixed;
    height: 150px;
    top: 50;
    z-index: 2;
    background: white;
    padding-top: 10px;
        width: 100%;
        margin-top: -10px;
}

#vrachtwagenModal textarea{
  height: 100px;
}

.vgt-wrap{
  margin-top: 120px;
}

label{
  vertical-align: top;
}

[data-g='1']{
  background: #8CC040;
}

[data-g='0']{
  background: red;
}
.btn-danger{
  margin-right: 210px;
}
</style>
